import { useState, useEffect } from "react";
import { MessageCircle, Phone, ArrowUp } from "lucide-react";
import { whatsappUrl } from "@/lib/whatsapp";

export default function FloatingButtons() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowScrollTop(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const fabBase =
    "group relative flex size-12 items-center justify-center rounded-full text-white shadow-lg transition-[transform,box-shadow] duration-300 ease-[cubic-bezier(0.34,1.3,0.64,1)] motion-reduce:transition-none focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#C5A880] active:scale-[0.94] sm:size-14 " +
    "hover:shadow-xl hover:shadow-black/20 md:hover:scale-[1.07]";

  return (
    <>
      {/* Left stack: WhatsApp (bottom) + Call (above), 16px gap — bottom/left 24px */}
      <div
        className="fixed bottom-4 left-4 z-40 flex flex-col-reverse items-center gap-4 sm:bottom-6 sm:left-6"
        aria-label="Quick contact"
      >
        <a
          href={whatsappUrl()}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="whatsapp-float-btn"
          className={`${fabBase} fab-float bg-[#25D366] pulse-ring`}
        >
          <MessageCircle className="relative z-[1] size-5 text-white transition-transform duration-300 group-hover:scale-110 sm:size-6" />
        </a>
        <a
          href="tel:9310965215"
          data-testid="call-float-btn"
          className={`${fabBase} fab-float fab-float-offset bg-[#C5A880]`}
        >
          <Phone className="size-5 text-white transition-transform duration-300 group-hover:scale-110 sm:size-6" />
        </a>
      </div>

      {/* Scroll to top — springy show/hide */}
      <button
        type="button"
        data-testid="scroll-top-btn"
        onClick={scrollToTop}
        aria-label="Scroll to top"
        className={`group fixed bottom-4 right-4 z-40 flex size-12 items-center justify-center rounded-full bg-[#111111] text-white shadow-lg transition-all duration-500 ease-[cubic-bezier(0.34,1.45,0.64,1)] motion-reduce:transition-none sm:bottom-6 sm:right-6 sm:h-14 sm:w-14 ${
          showScrollTop
            ? "pointer-events-auto translate-y-0 scale-100 opacity-100 shadow-black/20 md:hover:scale-105 md:hover:bg-[#C5A880] md:hover:shadow-xl"
            : "pointer-events-none translate-y-4 scale-90 opacity-0"
        } focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#C5A880] active:scale-95`}
      >
        <ArrowUp className="size-5 text-white transition-transform duration-300 group-hover:-translate-y-px" />
      </button>
    </>
  );
}
